import { render, staticRenderFns } from "./CompreviewChat.vue?vue&type=template&id=3260bea6&scoped=true&"
import script from "./CompreviewChat.vue?vue&type=script&lang=js&"
export * from "./CompreviewChat.vue?vue&type=script&lang=js&"
import style0 from "./CompreviewChat.vue?vue&type=style&index=0&id=3260bea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3260bea6",
  null
  
)

export default component.exports